<template>
  <v-container>
    <v-expansion-panel :value="expandedServiceIdx">
      <draggable
        class="draggable-container"
        :options="{ handle: '.exchange-service' }"
        v-model="servicesContainer"
        @end="updatePriority"
      >
        <service
          class="service"
          :key="service.id"
          :service="service"
          v-for="service in servicesContainer"
          v-on:deleteService="deleteService"
          v-on:duplicateService="duplicateService"
        />
      </draggable>
    </v-expansion-panel>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import Draggable from 'vuedraggable'
import Service from './Service'

export default {
  components: {
    Draggable,
    Service,
  },
  computed: {
    ...mapState('services', ['expandedServiceId']),
    expandedServiceIdx() {
      return this.servicesContainer.findIndex((service) => {
        return service.id === this.expandedServiceId
      })
    },
  },
  data() {
    return {
      servicesContainer: [],
    }
  },
  methods: {
    deleteService(serviceId) {
      this.$store.dispatch('services/deleteService', serviceId)
    },
    duplicateService(serviceId) {
      this.$store.dispatch('services/duplicateService', serviceId)
    },
    updatePriority(event) {
      this.servicesContainer.forEach((service, idx) => {
        if (service.attributes.priority !== idx) {
          let updatedService = JSON.parse(JSON.stringify(service))
          updatedService.attributes.priority = idx
          this.$store.dispatch('services/updateService', updatedService)
        }
      })
    },
  },
  mounted() {
    this.servicesContainer = this.services
  },
  watch: {
    services: {
      handler: function (newVal, oldVal) {
        if (newVal.length !== oldVal.length) {
          this.servicesContainer = Object.assign([], newVal).sort((a, b) => {
            return a.attributes.priority - b.attributes.priority
          })
        }
      },
      deep: true,
    },
  },
  props: ['services'],
}
</script>

<style scoped>
.draggable-container {
  width: 100%;
}

.service {
  background-color: #f9f9f9;
  border-bottom: 1px solid #ddd;
}
</style>
